<template>
  <div class="custTabs">&nbsp;</div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  created() {},
  computed: {}
}
</script>

<style></style>